import type { IconData } from '@stacksjs/iconify-core'

export const arrowDiagonal2Flat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M23.744 5.743c1.236-1.578.325-3.66-1.67-3.865c-5.406-.557-11.713-.413-16.674-.128a3.87 3.87 0 0 0-3.648 3.648c-.286 4.983-.43 11.325.136 16.747c.206 1.972 2.245 2.876 3.808 1.656c1.336-1.042 3.106-2.527 5.35-4.606c2.049 2.338 4.875 5.403 8.616 9.144c3.743 3.743 6.81 6.57 9.148 8.62c-2.036 2.205-3.508 3.961-4.554 5.296c-1.236 1.578-.325 3.66 1.67 3.865c5.406.558 11.713.413 16.674.128a3.87 3.87 0 0 0 3.648-3.648c.286-4.983.43-11.325-.136-16.747c-.206-1.972-2.245-2.876-3.808-1.656c-1.34 1.047-3.12 2.538-5.377 4.63a186 186 0 0 0-8.587-9.167a186 186 0 0 0-9.175-8.594c2.049-2.218 3.53-3.983 4.579-5.323\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowDiagonal2Flat
